import * as z from "zod";

export const getContextualSetupStatus = {
  name: "getContextualSetupStatus" as const,
  input: z.object({}),
  output: z.object({
    enabled: z.boolean(),
    ctxDomain: z.string().nullable(),
    cloudflareHostnameId: z.string().nullable(),
    /** Whether the ctx CNAME is live. False while tracking runs through the
     * shared endpoint, whether the merchant skipped the subdomain or their DNS
     * has not propagated yet. */
    subdomainActive: z.boolean(),
    isCtxMerchant: z.boolean(),
    storeUrl: z.string(),
    onboardingCompleted: z.boolean(),
    gtmContainerId: z.string().nullable(),
    pixelVerified: z.boolean(),
  }),
};
